module.exports = __webpack_public_path__ + "img/multiplataforma-orig.1f81e643.png";